import * as React from "react";
import { cn } from "../../lib/utils";

interface CustomTextFieldProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  label?: string;
  size?: "medium" | "large";
}

export const CustomTextField = React.forwardRef<
  HTMLInputElement,
  CustomTextFieldProps
>(({ label, className, size = "medium", ...props }, ref) => {
  const inputId = props.id || `text-field-${React.useId()}`;

  return (
    <div className={cn("w-full", className)}>
      {label && (
        <label
          htmlFor={inputId}
          className="text-sm font-medium mb-1 block text-foreground"
          tabIndex={-1}
        >
          {label}
        </label>
      )}
      <div
        className={cn(
          "relative w-full",
          "before:absolute before:bottom-0 before:left-0 before:h-px before:w-full before:bg-border",
          "after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-200 after:ease-out focus-within:after:w-full",
        )}
      >
        <div className="min-h-11 flex items-center px-2 py-1">
          <input
            id={inputId}
            ref={ref}
            className={cn(
              "w-full bg-transparent text-foreground",
              "outline-none",
              "placeholder:text-muted-foreground/70",
              size === "large" ? "text-lg" : "text-base",
            )}
            {...props}
          />
        </div>
      </div>
    </div>
  );
});

CustomTextField.displayName = "CustomTextField";

export default CustomTextField;
